var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlik = function SvgBlik(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41.5385,
    height: 20,
    viewBox: "0 0 41.5385 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "blik_Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "blik_Vector",
    d: "M39.0564 0H2.48054C1.11868 0 0 1.1358 0 2.51852V17.4815C0 18.8642 1.11868 20 2.48054 20H39.0564C40.4183 20 41.5369 18.8642 41.5369 17.4815V2.51852C41.5856 1.1358 40.4669 0 39.0564 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "blik_Vector_2",
    d: "M39.0563 19.7528H2.48046C1.26451 19.7528 0.291748 18.7651 0.291748 17.5306V2.51825C0.291748 1.28368 1.26451 0.296021 2.48046 0.296021H39.0563C40.2723 0.296021 41.245 1.28368 41.245 2.51825V17.4812C41.245 18.7158 40.2723 19.7528 39.0563 19.7528Z",
    fill: "url(#blik_paint0_linear_10540_150265)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "blik_Group_2",
    filter: "url(#blik_filter0_d_10540_150265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "blik_Vector_3",
    d: "M16.2392 5.13137C16.2392 3.94253 15.2868 2.99146 14.0963 2.99146C12.9058 2.99146 11.9535 3.94253 11.9535 5.13137C11.9535 6.3202 12.9058 7.27126 14.0963 7.27126C15.2868 7.22376 16.2392 6.27264 16.2392 5.13137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "blik_Vector_4",
    d: "M20.2867 3.65735H17.9058V17.0675H20.2867V3.65735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "blik_Vector_5",
    d: "M24.7629 8.31738H22.3819V17.1148H24.7629V8.31738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "blik_Vector_6",
    d: "M11.7629 8.2225C11.001 8.2225 10.2867 8.41275 9.62001 8.74562V3.65735H7.23907V12.6926C7.23907 15.1654 9.23907 17.1626 11.7153 17.1626C14.1914 17.1626 16.1914 15.1654 16.1914 12.6926C16.2391 10.2197 14.2391 8.2225 11.7629 8.2225ZM11.7629 14.88C10.5724 14.88 9.62001 13.9289 9.62001 12.7401C9.62001 11.5512 10.5724 10.6002 11.7629 10.6002C12.9534 10.6002 13.9058 11.5512 13.9058 12.7401C13.9058 13.9289 12.9534 14.88 11.7629 14.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "blik_Vector_7",
    d: "M20.2867 3.65735H17.9058V17.0675H20.2867V3.65735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "blik_Vector_8",
    d: "M24.7629 8.31738H22.3819V17.1148H24.7629V8.31738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "blik_Vector_9",
    d: "M11.7629 8.2225C11.001 8.2225 10.2867 8.41275 9.62001 8.74562V3.65735H7.23907V12.6926C7.23907 15.1654 9.23907 17.1626 11.7153 17.1626C14.1914 17.1626 16.1914 15.1654 16.1914 12.6926C16.2391 10.2197 14.2391 8.2225 11.7629 8.2225ZM11.7629 14.88C10.5724 14.88 9.62001 13.9289 9.62001 12.7401C9.62001 11.5512 10.5724 10.6002 11.7629 10.6002C12.9534 10.6002 13.9058 11.5512 13.9058 12.7401C13.9058 13.9289 12.9534 14.88 11.7629 14.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "blik_Vector_10",
    d: "M32.5724 17.1151H35.6199L31.9533 12.3597L35.2866 8.31762H32.5248L29.239 12.4072V3.65735H26.8581V17.1151H29.239V12.4072L32.5724 17.1151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "blik_Vector_11",
    d: "M14.0963 7.27126C15.2798 7.27126 16.2392 6.3132 16.2392 5.13137C16.2392 3.94953 15.2798 2.99146 14.0963 2.99146C12.9128 2.99146 11.9535 3.94953 11.9535 5.13137C11.9535 6.3132 12.9128 7.27126 14.0963 7.27126Z",
    fill: "url(#blik_paint1_linear_10540_150265)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "blik_filter0_d_10540_150265",
    x: 6.23907,
    y: 2.99146,
    width: 30.3809,
    height: 16.1712,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10540_150265"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10540_150265",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blik_paint0_linear_10540_150265",
    x1: 20.7684,
    y1: 19.7283,
    x2: 20.7684,
    y2: 0.320861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3459,
    stopColor: "#3E3E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7508,
    stopColor: "#262624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blik_paint1_linear_10540_150265",
    x1: 12.5991,
    y1: 3.63624,
    x2: 15.6254,
    y2: 6.66664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E53212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E95296"
  })))));
};
export default SvgBlik;